import "../sentryInstrument";
import React from 'react';

const defaultWebpThumbnail = "https://dummyimage.com/120x120/000/fff.jpg";
const defaultThumbnail = "https://dummyimage.com/120x120/000/fff.jpg";

function ShoppingCartRow({
  id, 
  product, 
  itemClass = "cart-row",
  thumbnail,
  webpThumbnail,
  price, 
  fullprice,
  quantity, 
  slug,
  handleQuantityInputChange,
  handleQuantityIncrease, 
  handleQuantityDecrease, 
  handleRemoveProduct,
  handleOnBlur,
  handleOnKeyUp,
  min,
  max,
  error
}) {
  let errorStyle;
  if (isNaN(quantity) || error) {
    errorStyle = {borderColor: 'red'}
  }


  return (
    <div className={itemClass}>
      <div className="product-image-wrap">
        <a href={window.gettext('/store/product/') + slug} title={`visit the product page for ${product}`}>
          <picture>
            <source srcSet={webpThumbnail ? webpThumbnail : defaultWebpThumbnail} type="image/webp" />
            <img loading="lazy" src={thumbnail ? thumbnail : defaultThumbnail} alt="" width="120" />
          </picture>
        </a>
      </div>
      <div className="product-info">
        <h2>{product}</h2>
        <p className="price">
          <strong>${price}</strong> &nbsp;
          {parseFloat(fullprice) > parseFloat(price) && (<small className='full-price'><span className='sale-price'>${fullprice}</span></small>)}
        </p>
        <div className="cart-options">
          <div 
            className="cart-counter" 
            style={errorStyle}
          >
            <button title={window.gettext("Subtract")}
              disabled={parseInt(quantity) <= parseInt(min) || isNaN(quantity)}
              className="minus cart-btn" 
              onClick={handleQuantityDecrease}
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                height="16px"
                width="16px"
                className="icon icon--counter"
              >
                <path d="M17 11a1 1 0 010 2H7a1 1 0 010-2h10z" />
              </svg>
            </button>
            <input 
              type="number" 
              id="quantity" 
              pattern="[0-9]*"
              className="qty text" 
              name={id} 
              value={quantity.toString()} 
              onChange={handleQuantityInputChange} 
              onBlur={handleOnBlur}
              onKeyUp={handleOnKeyUp}
              aria-label="Product quantity" 
              size="4" 
              step="1" 
              min={min}
              max={max}
              placeholder="" 
              autoComplete="off"
            />
            <button title={window.gettext("Add")}
              disabled={parseInt(quantity) >= parseInt(max) || isNaN(quantity)}
              className="plus cart-btn" 
              onClick={handleQuantityIncrease}
            >
              <svg
                fill="currentColor"
                viewBox="0 0 16 16"
                height="16px"
                width="16px"
                className="icon icon--counter"
              >
                <path d="M8 4a.5.5 0 01.5.5v3h3a.5.5 0 010 1h-3v3a.5.5 0 01-1 0v-3h-3a.5.5 0 010-1h3v-3A.5.5 0 018 4z" />
              </svg>
            </button>
          </div>
          <a className="cart-btn cart-btn--trash" onClick={handleRemoveProduct} title={window.gettext("Remove")}>
            <svg className="icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>
          </a>
        </div>
        {error && <div style={{borderColor: 'red', color: 'red'}}>{error}</div>}
      </div>
    </div>
  );
}

export default ShoppingCartRow;
